'use es6';

import { Map as ImmutableMap } from 'immutable';
import { mapPieToVisual } from './pie-mapper';
export const mapDonutToVisual = (report, datasets, reportOptions, params) => mapPieToVisual(report, datasets, reportOptions, params).updateIn(['layer', 'style'], (style = ImmutableMap()) => style.set('innerSize', '35%'));